import React from 'react';
import FileDropzone from './FileDropzone';

// Photo picker. Presentational — parent handles what to do with the files
// (usually: kick off preflight). The drag/drop + picker mechanics live in the
// shared FileDropzone; this file is the photo copy, icon and accept filter.

const PhotoStackIcon = () => (
  <svg
    className="pi-footage-tile-icon"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="6.5" y="7.5" width="15" height="12" rx="2" />
    <path d="M4 16.5V5.5a2 2 0 0 1 2-2h11" />
    <circle cx="10.5" cy="11.5" r="1.2" />
    <path d="m8 17 3.5-3.5 2.5 2.5 2.5-2.5 4 4" />
  </svg>
);

const PhotoDropzone = ({ onFiles, title, subtitle, disabled, variant }) => (
  <FileDropzone
    onFiles={onFiles}
    accept="image/*"
    multiple
    icon={<PhotoStackIcon />}
    title={title || (variant === 'tile' ? 'Upload photos' : 'Add photos')}
    subtitle={subtitle || (variant === 'tile'
      ? 'We group them by capture day and compile a timelapse'
      : 'We read capture dates automatically and group everything by day.')}
    ctaLabel="Choose photos"
    disabled={disabled}
    variant={variant}
    testId="photo-dropzone"
    inputTestId="photo-input"
  />
);

export default PhotoDropzone;
